import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import './styles/main.scss';
import { Provider } from 'react-redux';
import { store } from './redux/store/store';
// import '../src/fonts/Helvetica LT Std Bold Condensed.otf';

ReactDOM.render(
    <Provider store={ store }>
      <App />
    </Provider>,
  document.getElementById('root')
);
